import { Component } from "react";
import { resetDraft } from "../lib/workspace.js";

/**
 * Lỗi tải tệp mã sau một lần deploy: tab mở từ trước vẫn chạy bản cũ và đi tìm
 * các tệp công cụ đã bị bản mới thay thế. Không liên quan gì tới bản nháp, nên
 * không được bảo người dùng xoá bản nháp; tải lại trang là đủ.
 */
export const LA_LOI_TAI_MA = (e) =>
  /dynamically imported module|Importing a module script failed|error loading dynamically imported module|Failed to fetch|ChunkLoadError|Loading chunk/i
    .test(String(e?.message || e || ""));

const KHOA_TAI_LAI = "fvn-tai-lai-sau-deploy";

export default class ToolErrorBoundary extends Component {
  state = { failed: false, taiMa: false, message: "" };

  static getDerivedStateFromError(error) {
    return { failed: true, taiMa: LA_LOI_TAI_MA(error) };
  }

  componentDidCatch(error) {
    // Ghi ra console để lần sau còn biết lỗi thật là gì.
    console.error("[ToolErrorBoundary]", this.props.toolId, error);
    if (!LA_LOI_TAI_MA(error)) return;
    // Tự tải lại một lần. Mốc trong sessionStorage chặn vòng lặp tải lại nếu
    // lỗi vẫn còn sau khi đã lấy bản mới (ví dụ mất mạng).
    try {
      const lan = Number(sessionStorage.getItem(KHOA_TAI_LAI) || 0);
      if (Date.now() - lan > 60000) {
        sessionStorage.setItem(KHOA_TAI_LAI, String(Date.now()));
        window.location.reload();
      }
    } catch {
      /* không có sessionStorage: để người dùng tự bấm */
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    if (this.state.taiMa) {
      return (
        <div className="empty-state" role="alert">
          <h2>Website vừa được cập nhật</h2>
          <p>
            Trang này đang mở từ phiên bản trước. Tải lại để dùng bản mới, dữ
            liệu bạn đã nhập vẫn được giữ nguyên.
          </p>
          <button className="nut" onClick={() => window.location.reload()}>
            Tải lại trang
          </button>
        </div>
      );
    }
    return (
      <div className="empty-state" role="alert">
        <h2>Chưa mở được dữ liệu công cụ</h2>
        <p>
          Thử tải lại trang trước. Nếu vẫn lỗi, bản nháp có thể không tương
          thích: bạn có thể xuất bản sao trong Bản chuẩn bị của tôi trước khi
          xóa bản nháp này.
        </p>
        <div className="hang-nut" style={{ justifyContent: "center" }}>
          <button className="nut phu" onClick={() => window.location.reload()}>
            Tải lại trang
          </button>
          <button
            className="nut"
            onClick={() => {
              try {
                resetDraft(this.props.toolId);
                this.setState({ failed: false, taiMa: false });
              } catch {
                this.setState({
                  message: "Chưa xóa được. Kiểm tra bộ nhớ trình duyệt.",
                });
              }
            }}
          >
            Xóa bản nháp này và mở lại
          </button>
        </div>
        <p>{this.state.message}</p>
      </div>
    );
  }
}
